const add = (accumulator: number, a: number) => accumulator + a;

const sum = (array: number[]) => array.reduce(add, 0);

export default sum;
